module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepTwo"
  }, [_c('headers'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('steps', {
    attrs: {
      "step-num": 1
    }
  }), _vm._v(" "), (_vm.isCommon) ? _c('div', {
    staticClass: "stepTwo-content"
  }, [_c('div', {
    staticClass: "stepTow-tip"
  }, [_c('Icon', {
    attrs: {
      "type": "md-alert"
    }
  }), _vm._v(" "), _c('p', [_vm._v("检测到您在我校已绑定手机号 " + _vm._s(_vm.phoneNum) + "，如需修改，请先进行人脸核身验证。 "), _c('a', {
    on: {
      "click": _vm.goYz
    }
  }, [_vm._v("去验证>")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "stepTwo-form"
  }, [_c('p', {
    staticClass: "stepTwo-myphone"
  }, [_vm._v("手机号: " + _vm._s(_vm.phoneNum))]), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isDisable2
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getMobileCode2.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.getText2))])], 1)], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": _vm.handleSubmit2
    }
  }, [_vm._v("下一步")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isUpload) ? _c('div', {
    staticClass: "stepTwo-content"
  }, [_c('div', {
    staticClass: "stepTwo-form"
  }, [(_vm.isUploaded) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('Icon', {
    staticClass: "demo-spin-icon-load",
    attrs: {
      "type": "ios-loading",
      "size": "30"
    }
  }), _vm._v(" "), _c('div', [_vm._v("人脸核身验证中，请勿操作，请稍后...")])], 1) : _vm._e(), _vm._v(" "), (_vm.userImg == '') ? _c('div', [_c('div', {
    staticClass: "upload-box"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-images"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "imgFile",
    attrs: {
      "type": "file",
      "id": "imgId",
      "name": "image",
      "accept": "image/jpeg,image/jpg,image/png"
    },
    on: {
      "change": function($event) {
        return _vm.changeImg($event)
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "14px"
    }
  }, [_vm._v("请上传图片进行人脸核身，验证成功后可继续绑定手机号。")])]) : _vm._e(), _vm._v(" "), (!_vm.isUploaded && _vm.userImg != '') ? _c('div', {
    staticClass: "upload-box2"
  }, [_c('img', {
    staticClass: "user-img",
    attrs: {
      "src": _vm.userImg,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "go-bind"
  }, [_vm._v("已完成人脸核身，"), _c('a', {
    on: {
      "click": _vm.bindPhone
    }
  }, [_vm._v("绑定手机>")])])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.isTextPhone) ? _c('div', {
    staticClass: "stepTwo-content"
  }, [_c('div', {
    staticClass: "stepTwo-form"
  }, [_c('Form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 0
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入您的手机号"
    },
    model: {
      value: (_vm.formValidate.phone),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "phone", $$v)
      },
      expression: "formValidate.phone"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "code"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.formValidate.code),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "code", $$v)
      },
      expression: "formValidate.code"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isDisable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getMobileCode.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.getText))])], 1)], 1)], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formValidate')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1)]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29103c24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mobile/stepTwo.vue
// module id = 195
// module chunks = 0